import { ONE_DRIVE_PRO } from './constants';
import { assertNever } from 'owa-assert';
import { isFeatureEnabled } from 'owa-feature-flags';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';

export function getAttachmentPermissionLevelString(
    permissionLevel: AttachmentPermissionLevel,
    providerType: string
): string {
    if (providerType === ONE_DRIVE_PRO && isFeatureEnabled('doc-attachment-sharingDialog')) {
        return getODBAttachmentPermissionLevelString(permissionLevel);
    }

    switch (permissionLevel) {
        case AttachmentPermissionLevel.AnonymousView:
            return strings.AttachPerms_AnyoneCanView;
        case AttachmentPermissionLevel.AnonymousEdit:
            return strings.AttachPerms_AnyoneCanEdit;
        case AttachmentPermissionLevel.OrganizationEdit:
            return strings.AttachPerms_OrganizationEdit;
        case AttachmentPermissionLevel.OrganizationView:
            return strings.AttachPerms_OrganizationView;
        case AttachmentPermissionLevel.View:
            return providerType === ONE_DRIVE_PRO
                ? strings.AttachPerms_RecipientsCanView
                : strings.AttachPerms_AnyoneCanView;
        case AttachmentPermissionLevel.Edit:
            return providerType === ONE_DRIVE_PRO
                ? strings.AttachPerms_RecipientsCanEdit
                : strings.AttachPerms_AnyoneCanEdit;
        case AttachmentPermissionLevel.None:
            return strings.AttachPerms_NoPermissionToShare;
        default:
            return assertNever(permissionLevel);
    }
}

export function getODBAttachmentPermissionLevelString(
    permissionLevel: AttachmentPermissionLevel
): string {
    const companyName = getUserConfiguration().SessionSettings.CompanyName;
    switch (permissionLevel) {
        case AttachmentPermissionLevel.AnonymousView:
            return strings.ODBAttachPerms_AnyoneCanView;
        case AttachmentPermissionLevel.AnonymousEdit:
            return strings.ODBAttachPerms_AnyoneCanEdit;
        case AttachmentPermissionLevel.OrganizationEdit:
            return format(strings.ODBAttachPerms_OrganizationEdit, companyName);
        case AttachmentPermissionLevel.OrganizationView:
            return format(strings.ODBAttachPerms_OrganizationView, companyName);
        case AttachmentPermissionLevel.View:
            return strings.AttachPerms_RecipientsCanView;
        case AttachmentPermissionLevel.Edit:
            return strings.AttachPerms_RecipientsCanEdit;
        case AttachmentPermissionLevel.None:
            return strings.AttachPerms_NoPermissionToShare;
        default:
            return assertNever(permissionLevel);
    }
}
